export class KeyCodes {
    public static backspace = 8;
    public static tab = 9;
    public static clear = 12;
    public static enter = 13;
    public static shift = 16;
    public static ctrl = 17;
    public static alt = 18;
    public static pause = 19;
    public static break = 19;
    public static capsLock = 20;
    public static escape = 27;
    public static space = 32;
    public static pageUp = 33;
    public static pageDown = 34;
    public static end = 35;
    public static home = 36;
    public static leftArrow = 37;
    public static upArrow = 38;
    public static rightArrow = 39;
    public static downArrow = 40;
    public static select = 41;
    public static printScreen = 42;
    public static insert = 45;
    public static delete = 46;
    public static n0 = 48;
    public static n1 = 49;
    public static n2 = 50;
    public static n3 = 51;
    public static n4 = 52;
    public static n5 = 53;
    public static n6 = 54;
    public static n7 = 55;
    public static n8 = 56;
    public static n9 = 57;
    public static a = 65;
    public static b = 66;
    public static c = 67;
    public static d = 68;
    public static e = 69;
    public static f = 70;
    public static g = 71;
    public static h = 72;
    public static i = 73;
    public static j = 74;
    public static k = 75;
    public static l = 76;
    public static m = 77;
    public static n = 78;
    public static o = 79;
    public static p = 80;
    public static q = 81;
    public static r = 82;
    public static s = 83;
    public static t = 84;
    public static u = 85;
    public static v = 86;
    public static w = 87;
    public static x = 88;
    public static y = 89;
    public static z = 90;
    public static leftWindowKey = 91;
    public static rightWindowKey = 92;
    public static selectKey = 93;
    public static numpad0 = 96;
    public static numpad1 = 97;
    public static numpad2 = 98;
    public static numpad3 = 99;
    public static numpad4 = 100;
    public static numpad5 = 101;
    public static numpad6 = 102;
    public static numpad7 = 103;
    public static numpad8 = 104;
    public static numpad9 = 105;
    public static multiply = 106;
    public static add = 107;
    public static subtract = 109;
    public static decimalPoint = 110;
    public static divide = 111;
    public static f1 = 112;
    public static f2 = 113;
    public static f3 = 114;
    public static f4 = 115;
    public static f5 = 116;
    public static f6 = 117;
    public static f7 = 118;
    public static f8 = 119;
    public static f9 = 120;
    public static f10 = 121;
    public static f11 = 122;
    public static f12 = 123;
    public static numLock = 144;
    public static scrollLock = 145;
    public static semiColon = 186;
    public static equalSign = 187;
    public static comma = 188;
    public static dash = 189;
    public static period = 190;
    public static forwardSlash = 191;
    public static graveAccent = 192;
    public static openBracket = 219;
    public static backSlash = 220;
    public static singleQuote = 222;
    public static closeBraket = 221;
    public static numeric = [
        KeyCodes.n0,
        KeyCodes.n1,
        KeyCodes.n2,
        KeyCodes.n3,
        KeyCodes.n4,
        KeyCodes.n5,
        KeyCodes.n6,
        KeyCodes.n7,
        KeyCodes.n8,
        KeyCodes.n9,
        KeyCodes.numpad0,
        KeyCodes.numpad1,
        KeyCodes.numpad2,
        KeyCodes.numpad3,
        KeyCodes.numpad4,
        KeyCodes.numpad5,
        KeyCodes.numpad6,
        KeyCodes.numpad7,
        KeyCodes.numpad8,
        KeyCodes.numpad9,
    ];
    public static alpha = [
        KeyCodes.a,
        KeyCodes.b,
        KeyCodes.c,
        KeyCodes.d,
        KeyCodes.e,
        KeyCodes.f,
        KeyCodes.g,
        KeyCodes.h,
        KeyCodes.i,
        KeyCodes.j,
        KeyCodes.k,
        KeyCodes.l,
        KeyCodes.m,
        KeyCodes.n,
        KeyCodes.o,
        KeyCodes.p,
        KeyCodes.q,
        KeyCodes.r,
        KeyCodes.s,
        KeyCodes.t,
        KeyCodes.u,
        KeyCodes.v,
        KeyCodes.w,
        KeyCodes.x,
        KeyCodes.y,
        KeyCodes.z,
    ];
    public static Fkeys =
    [
        KeyCodes.f1,
        KeyCodes.f2,
        KeyCodes.f3,
        KeyCodes.f4,
        KeyCodes.f5,
        KeyCodes.f6,
        KeyCodes.f7,
        KeyCodes.f8,
        KeyCodes.f9,
        KeyCodes.f10,
        KeyCodes.f11,
        KeyCodes.f12,
    ];
}
export class KeyboardEventCode {
    public static backspace = 'Backspace';
    public static tab = 'Tab';
    public static clear = 'NumpadClear';
    public static enter = 'Enter';
    public static shiftLeft = 'ShiftLeft';
    public static shiftRight = 'ShiftRight';
    public static ctrlLeft = 'ControlLeft';
    public static ctrlRight = 'ControlRight';
    public static altLeft = 'AltLeft';
    public static altRight = 'AltRight';
    public static pause = 'Pause';
    public static break = 'Break';
    public static capsLock = 'CapsLock';
    public static escape = 'Escape';
    public static space = 'Space';
    public static pageUp = 'PageUp';
    public static pageDown = 'PageDown';
    public static end = 'End';
    public static home = 'Home';
    public static leftArrow = 'ArrowLeft';
    public static upArrow = 'ArrowUp';
    public static rightArrow = 'ArrowRight';
    public static downArrow = 'ArrorDown';
    public static select = 'Select';
    public static printScreen = 'PrintScreen';
    public static insert = 'Insert';
    public static delete = 'Delete';
    public static n0 = 'Digit0';
    public static n1 = 'Digit1';
    public static n2 = 'Digit2';
    public static n3 = 'Digit3';
    public static n4 = 'Digit4';
    public static n5 = 'Digit5';
    public static n6 = 'Digit6';
    public static n7 = 'Digit7';
    public static n8 = 'Digit8';
    public static n9 = 'Digit9';
    public static a = 'KeyA';
    public static b = 'KeyB';
    public static c = 'KeyC';
    public static d = 'KeyD';
    public static e = 'KeyE';
    public static f = 'KeyF';
    public static g = 'KeyG';
    public static h = 'KeyH';
    public static i = 'KeyI';
    public static j = 'KeyJ';
    public static k = 'KeyK';
    public static l = 'KeyL';
    public static m = 'KeyM';
    public static n = 'KeyN';
    public static o = 'KeyO';
    public static p = 'KeyP';
    public static q = 'KeyQ';
    public static r = 'KeyR';
    public static s = 'KeyS';
    public static t = 'KeyT';
    public static u = 'KeyU';
    public static v = 'KeyV';
    public static w = 'KeyW';
    public static x = 'KeyX';
    public static y = 'KeyY';
    public static z = 'KeyZ';
    public static leftMetaKey = 'MetaLeft';
    public static rightMetaKey = 'MetaRight';
    public static leftOSKey = 'OSLeft';
    public static rightOSKey = 'OSRight';
    public static selectKey = 'Select';
    public static numpad0 = 'Numpad0';
    public static numpad1 = 'Numpad1';
    public static numpad2 = 'Numpad2';
    public static numpad3 = 'Numpad3';
    public static numpad4 = 'Numpad4';
    public static numpad5 = 'Numpad5';
    public static numpad6 = 'Numpad6';
    public static numpad7 = 'Numpad7';
    public static numpad8 = 'Numpad8';
    public static numpad9 = 'Numpad9';
    public static star = 'NumpadStar'
    public static multiply = 'NumpadMultiply';
    public static add = 'NumpadAdd';
    public static subtract = 'NumpadSubtract';
    public static decimalPoint = 'NumpadDecimal';
    public static divide = 'NumpadDivide';
    public static f1 = 'F1';
    public static f2 = 'F2';
    public static f3 = 'F3';
    public static f4 = 'F4';
    public static f5 = 'F5';
    public static f6 = 'F6';
    public static f7 = 'F7';
    public static f8 = 'F8';
    public static f9 = 'F9';
    public static f10 = 'F10';
    public static f11 = 'F11';
    public static f12 = 'F12';
    public static numLock = 'NumLock';
    public static scrollLock = 'ScrollLock';
    public static semiColon = 'SemiColon';
    public static equalSign = 'Equals';
    public static comma = 'Comma';
    public static dash = 'Minus';
    public static period = 'Period';
    public static forwardSlash = 'Slash';
    public static graveAccent = 'BackQuote';
    public static openBracket = 'BracketLeft';
    public static backSlash = 'Backslash';
    public static singleQuote = 'Quote';
    public static closeBraket = 'BracketRight';
    public static numeric = [
        KeyboardEventCode.n0,
        KeyboardEventCode.n1,
        KeyboardEventCode.n2,
        KeyboardEventCode.n3,
        KeyboardEventCode.n4,
        KeyboardEventCode.n5,
        KeyboardEventCode.n6,
        KeyboardEventCode.n7,
        KeyboardEventCode.n8,
        KeyboardEventCode.n9,
        KeyboardEventCode.numpad0,
        KeyboardEventCode.numpad1,
        KeyboardEventCode.numpad2,
        KeyboardEventCode.numpad3,
        KeyboardEventCode.numpad4,
        KeyboardEventCode.numpad5,
        KeyboardEventCode.numpad6,
        KeyboardEventCode.numpad7,
        KeyboardEventCode.numpad8,
        KeyboardEventCode.numpad9,
    ];
    public static alpha = [
        KeyboardEventCode.a,
        KeyboardEventCode.b,
        KeyboardEventCode.c,
        KeyboardEventCode.d,
        KeyboardEventCode.e,
        KeyboardEventCode.f,
        KeyboardEventCode.g,
        KeyboardEventCode.h,
        KeyboardEventCode.i,
        KeyboardEventCode.j,
        KeyboardEventCode.k,
        KeyboardEventCode.l,
        KeyboardEventCode.m,
        KeyboardEventCode.n,
        KeyboardEventCode.o,
        KeyboardEventCode.p,
        KeyboardEventCode.q,
        KeyboardEventCode.r,
        KeyboardEventCode.s,
        KeyboardEventCode.t,
        KeyboardEventCode.u,
        KeyboardEventCode.v,
        KeyboardEventCode.w,
        KeyboardEventCode.x,
        KeyboardEventCode.y,
        KeyboardEventCode.z,
    ];
    public static shiftKeys = [
        KeyboardEventCode.shiftLeft,
        KeyboardEventCode.shiftRight
    ];
    public static ctrlKeys = [
        KeyboardEventCode.ctrlLeft,
        KeyboardEventCode.ctrlRight
    ];
    public static altKeys = [
        KeyboardEventCode.altLeft,
        KeyboardEventCode.altRight
    ];
    public static Fkeys =
    [
        KeyboardEventCode.f1,
        KeyboardEventCode.f2,
        KeyboardEventCode.f3,
        KeyboardEventCode.f4,
        KeyboardEventCode.f5,
        KeyboardEventCode.f6,
        KeyboardEventCode.f7,
        KeyboardEventCode.f8,
        KeyboardEventCode.f9,
        KeyboardEventCode.f10,
        KeyboardEventCode.f11,
        KeyboardEventCode.f12,
    ];
}
